import { Category } from '@/domain/models/content/category'
import { EnrollmentCategory } from '@/domain/models/content/enrollment-category'
import { ReactNode, lazy } from 'react'

const HomePage = lazy(() => import('@/presentation/pages/home/home-page'))
const SearchPage = lazy(() => import('@/presentation/pages/search/search-page'))
const FavoritesPage = lazy(() => import('@/presentation/pages/favorites/favorites-page'))
const CategorySearchPage = lazy(() => import('@/presentation/pages/search/category-search-page'))
const CategoryGroupSearchPage = lazy(
  () => import('@/presentation/pages/search/category-group-search-page')
)
const SkillSearchPage = lazy(() => import('@/presentation/pages/search/skill-search-page'))
const InstitutionSearchPage = lazy(
  () => import('@/presentation/pages/search/institution-search-page')
)
const InstitutionsSearchPage = lazy(
  () => import('@/presentation/pages/search/institutions-search-page')
)
const ContentPage = lazy(() =>
  import('@/presentation/pages/content/content-details/content-page-with-context').then(module => ({
    default: module.DefaultContentPage
  }))
)

export const makeHomePage = (): ReactNode => {
  return <HomePage />
}

export const makeSearchPage = (): ReactNode => {
  return <SearchPage />
}

export const makeFavoritesPage = (): ReactNode => {
  return <FavoritesPage />
}

export const makeCategorySearchPage = (category: Category.Enum): ReactNode => {
  return <CategorySearchPage category={category} />
}

export const makeCategoryGroupSearchPage = (group: EnrollmentCategory.Enum): ReactNode => {
  return <CategoryGroupSearchPage group={group} />
}

export const makeSkillSearchPage = (): ReactNode => {
  return <SkillSearchPage />
}

export const makeInstitutionSearchPage = (): ReactNode => {
  return <InstitutionSearchPage />
}

export const makeInstitutionsSearchPage = (): ReactNode => {
  return <InstitutionsSearchPage />
}

export const makeContentPage = (): ReactNode => {
  return <ContentPage />
}
